import { useMemo, useState } from "react";
import styles from "../../Detalhe/detalhe.styles.module.css";

/**
 * @param {object} props
 * @param {Array<{id:string,label:string,filter:string}>} props.colunas
 * @param {Array<{campo:string,tipo:string,valor?:string,valor2?:string}>} props.filtros
 * @param {(filtros:Array) => void} props.onChange
 */
export default function FiltrosDinamicosLancamentos({ colunas, filtros, onChange }) {
  const [campoAdd, setCampoAdd] = useState(colunas[0]?.id || "");

  const disponiveis = useMemo(
    () => colunas.filter((c) => !filtros.some((f) => f.campo === c.id)),
    [colunas, filtros]
  );

  const handleAdd = () => {
    const col = colunas.find((c) => c.id === campoAdd);
    if (!col || filtros.some((f) => f.campo === col.id)) return;
    onChange([
      ...filtros,
      {
        campo: col.id,
        tipo: col.filter,
        valor: "",
        valor2: "",
      },
    ]);
  };

  const handleRemove = (campo) => {
    onChange(filtros.filter((f) => f.campo !== campo));
  };

  const handleChange = (campo, patch) => {
    onChange(
      filtros.map((f) => (f.campo === campo ? { ...f, ...patch } : f))
    );
  };

  const handleLimpar = () => onChange([]);

  return (
    <div className={styles.lancFiltrosWrap}>
      <div className={styles.lancFiltrosRow}>
        <span className={styles.lancFiltrosTitle}>Filtros</span>
        <select
          className={styles.lancFiltroSelect}
          value={campoAdd}
          onChange={(e) => setCampoAdd(e.target.value)}
          aria-label="Campo de filtro"
        >
          {disponiveis.map((c) => (
            <option key={c.id} value={c.id}>
              {c.label}
            </option>
          ))}
        </select>
        <button
          type="button"
          className={styles.btnFiltroAdd}
          onClick={handleAdd}
          disabled={!disponiveis.length}
        >
          + Adicionar
        </button>
        <button type="button" className={styles.btnFiltroLimpar} onClick={handleLimpar}>
          Limpar
        </button>
      </div>

      <div className={styles.lancFiltrosAtivos}>
        {!filtros.length ? (
          <p className={styles.lancFiltrosVazio}>
            Nenhum filtro ativo. Use «Adicionar» para refinar a busca.
          </p>
        ) : (
          filtros.map((filtro) => {
            const col = colunas.find((c) => c.id === filtro.campo);
            if (!col) return null;
            return (
              <div key={filtro.campo} className={styles.lancFiltroAtivo}>
                <span className={styles.lancFiltroLabel}>{col.label}</span>
                <input
                  type="text"
                  className={styles.lancFiltroInput}
                  placeholder={filtro.tipo === "range" ? "Mín." : "Contém…"}
                  value={filtro.valor ?? ""}
                  onChange={(e) => handleChange(filtro.campo, { valor: e.target.value })}
                />
                {filtro.tipo === "range" && (
                  <input
                    type="text"
                    className={styles.lancFiltroInput}
                    placeholder="Máx."
                    value={filtro.valor2 ?? ""}
                    onChange={(e) => handleChange(filtro.campo, { valor2: e.target.value })}
                  />
                )}
                <button
                  type="button"
                  className={styles.lancFiltroRemove}
                  onClick={() => handleRemove(filtro.campo)}
                  aria-label={`Remover filtro ${col.label}`}
                >
                  ×
                </button>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
